/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S6_P2Inputs */

const en_guide_json_schema_s6_p2 = /** @type {(inputs: Guide_Json_Schema_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It also doubles as documentation that cannot drift. Because the schema is machine readable, the same file can validate data, generate example payloads, and drive editor autocomplete. Teams often keep the schema next to the code so a change to the data shape and a change to its rules travel together in the same review.`)
};

const ko_guide_json_schema_s6_p2 = /** @type {(inputs: Guide_Json_Schema_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스키마는 어긋날 수 없는 문서 역할도 겸합니다. 기계가 읽을 수 있으므로 같은 파일 하나로 데이터를 검증하고, 예시 페이로드를 생성하고, 에디터 자동 완성을 구동할 수 있습니다. 많은 팀이 스키마를 코드 옆에 두어, 데이터 형태의 변경과 그 규칙의 변경이 같은 리뷰에서 함께 움직이게 합니다.`)
};

const ja_guide_json_schema_s6_p2 = /** @type {(inputs: Guide_Json_Schema_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スキーマはずれることのない文書の役割も兼ねます。機械が読めるので、同じ一つのファイルでデータを検証し、例のペイロードを生成し、エディターの自動補完を駆動できます。多くのチームはスキーマをコードの隣に置き、データ形状の変更とその規則の変更が同じレビューで一緒に動くようにしています。`)
};

/**
* | output |
* | --- |
* | "It also doubles as documentation that cannot drift. Because the schema is machine readable, the same file can validate data, generate example payloads, and d..." |
*
* @param {Guide_Json_Schema_S6_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s6_p2 = /** @type {((inputs?: Guide_Json_Schema_S6_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S6_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s6_p2(inputs)
	if (locale === "ko") return ko_guide_json_schema_s6_p2(inputs)
	return ja_guide_json_schema_s6_p2(inputs)
});